import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IndustryFocus from "./components/IndustryFocus";
import Solutions from "./components/Solutions";
import Process from "./components/Process";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <IndustryFocus />
      <Solutions />
        <Process />
      <CTA />
      <Footer />
       <Chatbot />
    </>
  );
}
